export const decodeBase64 = (b64Encoded: string) => {
  try {
    return atob(b64Encoded);
  } catch {
    return Buffer.from(b64Encoded, 'base64').toString();
  }
};

export const encodeBase64 = (b64Encoded: string) => {
  try {
    return btoa(b64Encoded);
  } catch {
    return Buffer.from(b64Encoded).toString('base64');
  }
};

/**
 * Re-reverses reversed person names
 * _Example: Transforms `'Doe, Jane'` back to `'Jane Doe'`_
 */
export const reverseName = (name: string) => {
  const reversed = name?.split(', ').reverse().join(' ') ?? '';
  return reversed === 'Janicke Falck' ? 'Janicke Falch' : reversed; // 🙃
};

export const kebabCasePattern = '[a-z0-9]+(?:-[a-z0-9]+)*';

export const camelCasePattern = '([a-z0-9]([a-zA-Z0-9]+)?)';

export const camelCasePatternWithUnderscore = '([a-z0-9]([a-zA-Z0-9_]+)?)';
